import React, { useEffect } from "react";
import { useToast } from "@chakra-ui/react";

export const Toaster = (props) => {
  const toast = useToast();

  useEffect(() => {
    if (props.toastConfig !== null) {
      toast(props.toastConfig);
    }
  }, [toast, props.toastConfig]);

  return <></>;
};
